import React, { type FC } from "react";
import { useCustomTranslation } from "clientState/AuthFlow/hooks";
import { useModalState } from "clientState/AuthFlow/providers/ModalScreenProvider";
import {
  screenNames,
  useScreenActions,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { Flex, SystemModalContent } from "@edreamsodigeo/prisma-design-system";

import Footer from "../Footer";
import { MODAL_STYLES } from "../Helpers/ModalStyles";
import ScreenHeader, { type ScreenHeaderProps } from "../ScreenHeader";
import type {
  ForgotPasswordBodyProps,
  ForgotPasswordContentProps,
} from "./contract";
import ForgotPasswordBody from "./ForgotPasswordBody";

const { FORGOT_PASSWORD } = screenNames;

const ForgotPasswordContent: FC<ForgotPasswordContentProps> = ({
  trackingPrefix,
}) => {
  const { customTranslation } = useCustomTranslation();
  const { titleColor } = useModalState();
  const screenActions = useScreenActions();
  const { content: button } = customTranslation({
    customKey: "authentication.forgotPassword.submit",
    defaultKey: "authentication.forgotPassword.submit",
  });
  const { content: title, showComponent: showTitle } = customTranslation({
    customKey: "authentication.forgotPassword.title",
    defaultKey: "authentication.forgotPassword.title",
  });
  const { content: subtitle, showComponent: showSubtitle } = customTranslation({
    customKey: "authentication.forgotPassword.subtitle",
    defaultKey: "authentication.forgotPassword.subtitle",
  });

  const { content: emailLabelForm } = customTranslation({
    customKey: "authentication.forgotPassword.emailLabelForm",
    defaultKey: "auth.form.email.label",
  });
  const forgotPasswordHeaderProps: ScreenHeaderProps = {
    title: {
      content: title,
      color: titleColor,
    },
    showTitle,
    subtitle,
    showSubtitle,
  };
  const forgotPasswordBodyProps: ForgotPasswordBodyProps = {
    submitButtonLabel: button,
    emailLabelForm,
    ...screenActions,
  };
  return (
    <SystemModalContent>
      <Flex flexDirection="column" sx={MODAL_STYLES}>
        <ScreenHeader {...forgotPasswordHeaderProps} />
        <ForgotPasswordBody
          {...forgotPasswordBodyProps}
          trackingPrefix={trackingPrefix}
        />
        <Footer withGeneralTC withRecaptchaPolicy screen={FORGOT_PASSWORD} />
      </Flex>
    </SystemModalContent>
  );
};

export default ForgotPasswordContent;
